import { render } from "./comex-trades.vue?vue&type=template&id=64b4206f&scoped=true"
import script from "./comex-trades.vue?vue&type=script&lang=js"
export * from "./comex-trades.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./comex-trades.vue?vue&type=style&index=1&id=64b4206f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b4206f"]])

export default __exports__